import request from '@/utils/request'

export function getStudyData(data) {
    return request({
        url: '/backend/course/getStudyData',
        method: 'post',
        data: data
    })
}

export function getStudyUserList(data) {
    return request({
        url: '/backend/course/getStudyUserList',
        method: 'post',
        data: data
    })
}

// 获取按天统计的学习数据（学习人数和学习人次）
export function getDailyLearningData(data) {
    return request({
        url: '/backend/course/getRecentStudyData',
        method: 'post',
        data: data
    })
}

// 获取学习时长统计数据
export function getStudyDurationData(data) {
    return request({
        url: '/backend/course/getPeriodStudyDuration',
        method: 'post',
        data: data
    })
}

// 获取学习用户学习时长列表
export function getUserStudyDurationList(data) {
    return request({
        url: '/backend/course/getUserPeriodStudyDurationList',
        method: 'post',
        data: data
    })
}